
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { ControlButton } from "@/oxygen/classes/lib/types";
import Icon from "@/components/UI/Icon.vue";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: { IconButton, Icon }
})
export default class OxygenButtonInput extends Vue {
  @Prop()
  control!: ControlButton;

  @ModelSync("value", "input", { type: Boolean })
  syncedValue?: boolean;
}
